interface HeroProps {
  title: string;
  subtitle: string;
}

export function Hero({ title, subtitle }: HeroProps) {
  return (
    <section
      className="h-[500px] flex flex-col justify-center items-center text-center text-white relative mt-[92px] bg-cover bg-center bg-no-repeat max-md:h-[280px] max-md:mt-[92px]"
      style={{
        backgroundImage:
          "image-set(url('/images/cropped-cropped-brandon-green-F_KScPBU93I-unsplash-1-1.webp') type('image/webp'), url('/images/cropped-cropped-brandon-green-F_KScPBU93I-unsplash-1-1.jpg') type('image/jpeg'))",
      }}
    >
      <div className="absolute inset-0 bg-black/30" />
      <div className="relative z-[1] px-5">
        <h1 className="text-5xl font-bold uppercase tracking-[8px] mb-5 [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)] max-md:text-xl max-md:tracking-[2px] max-md:mb-3">
          {title}
        </h1>
        <p className="text-2xl capitalize tracking-[3px] [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)] max-md:text-base max-md:tracking-[1px]">
          {subtitle}
        </p>
      </div>
    </section>
  );
}
